const { Core, Events, DOMEvents } = Global;
const { $fetch, $replaceContent, $toggleDisplay } = Global.Utils;

const R_PRODUC_CARD_SECTION = "r_product-bundle-card";
const SEL_BUNDLE_CARD = "#product-bundle-card";
const SEL_BUNDLE_CARD_TEMPLATE = "[data-card-template]";

function _getPriceValue(el) {
    return Number(el.dataset.priceValue);
}

customElements.define('product-bundle', class extends Core {
    propTypes = {
        'product-url': String,
        'initial-variant': String,
        'subtotal': Number,
        'selected-count': Number
    }

    elements = {
        $: [['product-bundle-item'], 'subtotal', 'main-product', 'main-product-meta', 'footer'],
        'button-counter': '[data-i18n-amount]',
        'quantity-selector': '[data-quantity-selector]'
    }

    render() {
        this._initValues();

        this.sub(Events.PRODUCT_BUNDLE_VARIANT_CHANGE, this._handleVariantChange, { global: true });
        this.$('product-bundle-item', {
            change: this._handleChange
        });

        this.$('main-product', {
            update: this._handleMainProductUpdate
        });

        // Add quantity change listener
        const quantitySelector = this.$('quantity-selector');
        if (quantitySelector) {
            quantitySelector.addEventListener('change', this._handleQuantityChange.bind(this));
        }

      
        this._renderFooter();

        // // 🔘 Auto-select the item with variant ID 7927418683485
        // const matchingCard = this.$('product-bundle-item').find(item => {
        //   const checkbox = item.querySelector('[data-item-checkbox]');
        //   return checkbox && (checkbox.dataset.clId === "7927418683485" || checkbox.dataset.clId === "7835436482653" || checkbox.dataset.clId === "7866545635421" || checkbox.dataset.clId === "8011961827421");
        // });

        // Get the main product ID first
        const mainProductId = this.closest('[data-product-id]')?.dataset.productId || 
                            document.querySelector('[dat-element="main-product"]')?.dataset.productId ||
                            // Or however you can access the main product ID in your context
                            this.dataset.mainProductId;

        console.log('Main Product ID:', mainProductId); // 🔍 Debug - remove after testing

        // Define combinations that should be auto-selected
        // Format: "mainProductId:complementaryProductId"
        const autoSelectCombinations = [
            "7895416799325:7866545635421",
            "7836573597789:8011961827421",
            "7866509328477:7866486980701",
            "7866509361245:7866486980701",
            "8011907727453:7866486980701",
            "7872577536093:8022584164445",
            "7835113193565:7866505232477",
            "7833751060573:7866505232477",
            "7835113029725:7866505232477",
        ];

        // 🔘 Auto-select matching items
        const matchingCard = this.$('product-bundle-item').find(item => {
            const checkbox = item.querySelector('[data-item-checkbox]');
            if (!checkbox) return false;
            
            const complementaryId = checkbox.dataset.clId;
            const comboKey = `${mainProductId}:${complementaryId}`;
            
            return autoSelectCombinations.includes(comboKey);
        });
        
        if (matchingCard) {
          const checkbox = matchingCard.querySelector('[data-item-checkbox]');
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // 🔘 Auto-select anything Liquid flagged with [data-auto-select]
        // (covers both id-based disabled_indices and tag-based tag_disabled_indices).
        // Idempotent: skips items already checked above.
        console.group('[product-bundle] data-auto-select pass');
        const allItems = this.$('product-bundle-item');
        console.log('Total bundle items found:', allItems.length);
        allItems.forEach((item, i) => {
            const anyCheckbox = item.querySelector('[data-item-checkbox]');
            const flagged = item.querySelector('[data-item-checkbox][data-auto-select]');
            console.log(`  [${i}] product-id=${item.dataset.productId}`, {
                hasCheckbox: !!anyCheckbox,
                hasAutoSelect: !!flagged,
                disabled: anyCheckbox?.disabled,
                checkedBefore: anyCheckbox?.checked,
                outerHTML: anyCheckbox?.outerHTML?.slice(0, 200)
            });
        });
        allItems.forEach(item => {
            const checkbox = item.querySelector('[data-item-checkbox][data-auto-select]');
            if (!checkbox) return;
            if (checkbox.checked) {
                console.log('  ↳ already checked, skipping', checkbox.dataset.clId);
                return;
            }
            checkbox.checked = true;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            console.log('  ↳ auto-selected', checkbox.dataset.clId, 'now checked=', checkbox.checked);
        });
        console.groupEnd();
    }

    _initValues() {
        this.mainPrice = _getPriceValue(this.$('main-product-meta'));
        this.baseSubtotal = this.prop('subtotal');
        this.subtotal = this.baseSubtotal;
        this.selectedCount = 0; //this.prop('selected-count');
        this.quantity = 1;
        this.btnWrapper = document.querySelector('.product-form-button__wrapper');

      
        // this.mainPrice = _getPriceValue(this.$('main-product-meta'));
        // this.baseSubtotal = this.prop('subtotal');
        // this.subtotal = this.baseSubtotal;
        // this.selectedCount = this.prop('selected-count');
        // this.quantity = 1;
        // this.btnWrapper = document.querySelector('.product-form-button__wrapper');
    
    }

    _handleQuantityChange(e) {
        const input = e.target;
        const newQuantity = parseInt(input.value);
        
        if (isNaN(newQuantity) || newQuantity < 1) return;
        
        this.quantity = newQuantity;
        
        // Update main product quantity
        document.querySelectorAll('.main-product-quantity').forEach(input => {
            input.value = newQuantity;
        });
        
        // Update complementary products quantities
        this.$('product-bundle-item').forEach(item => {
            const checkbox = item.querySelector('[data-item-checkbox]');
            const quantityInput = item.querySelector('.complementary-product-quantity');
            if (checkbox && quantityInput) {
                if (checkbox.checked) {
                    quantityInput.value = newQuantity;
                } else {
                    quantityInput.value = 1; // or 0 if you want to prevent submission
                }
            }
        });
        
        this._updateSubtotal();
    }

    _updateSubtotal() {
        // Calculate base subtotal (price of main product + selected complementary products)
        let baseSubtotal = this.mainPrice;
        this.$('product-bundle-item').forEach(item => {
            const checkbox = item.querySelector('[data-item-checkbox]');
            if (checkbox?.checked) {
                baseSubtotal += _getPriceValue(checkbox);
            }
        });
        
        // Multiply by quantity
        this.subtotal = baseSubtotal * this.quantity;
        this._renderSubtotal();
    }

    _handleMainProductUpdate() {
        const productMeta = this.$('main-product-meta');

        $toggleDisplay(this, productMeta.dataset.available);
        
        const updatedMainPrice = _getPriceValue(productMeta);
        if(this.mainPrice === updatedMainPrice) {
            return;
        }
        this.mainPrice = updatedMainPrice;
        this._updateSubtotal();
    }

    _handleChange(e) {
        try { 
            if(e.target.tagName === 'INPUT' && e.target.type === 'checkbox') {
                this._handleCheckboxChange(e);
                return;
            };
            throw new Error('invalid change event');
        } catch(e) {
            console.error(e);
        }
    }

    _handleCheckboxChange(e) {
        // Update selectedCount
        const checkbox = e.target;
        if (checkbox.checked) {
            this.selectedCount++;
        } else {
            this.selectedCount--;
        }

        // For each complementary product, enable/disable its hidden inputs based on its own checkbox
        this.$('product-bundle-item').forEach(item => {
            const itemCheckbox = item.querySelector('[data-item-checkbox]');
            const idInput = item.querySelector('input[name="id[]"]');
            const quantityInput = item.querySelector('input[name="quantity[]"]');
            if (idInput && quantityInput && itemCheckbox) {
                if (itemCheckbox.checked) {
                    idInput.disabled = false;
                    quantityInput.disabled = false;
                } else {
                    idInput.disabled = true;
                    quantityInput.disabled = true;
                }
            }
        });

        this._updateSubtotal();
        this._renderFooter();
        this._updateButtonCount();
    }

    async _handleVariantChange(data) {
        const $currentCard = this.$('product-bundle-item').find(item => +item.dataset.productId === data.productId);
        this._setChecked($currentCard, false);
        const cardContent = await this._fetchCard(data.productURL, data.variantId);
        $replaceContent($currentCard, cardContent);
        this._setChecked($currentCard, true);
    }

    _setChecked($card, state) {
        const $checkbox = $card.querySelector([data-item-checkbox]);
        if(!state && $checkbox.checked || state && !$checkbox.checked) {
            $checkbox.checked = state;
            $checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            return
        }
    }

    async _fetchCard(productURL, variantId) {
        try {
            return await $fetch(productURL, {
                params: {
                    variant: variantId,
                    section_id: R_PRODUC_CARD_SECTION
                },
                select: SEL_BUNDLE_CARD_TEMPLATE
            });
        } catch(err) {
            console.error(err);
        }
    }

    _renderFooter() {
        $toggleDisplay(this.$('footer'), this.selectedCount > 0);
        if (this.btnWrapper) {
            this.btnWrapper.style.display = this.selectedCount <= 0 ? 'flex' : 'none';
        }
    }

    _updateButtonCount() {
        // count with the main product
        this.$('button-counter').innerText = this.selectedCount + 1;
    }

    _renderSubtotal() {
        const renderValue = Shopify.formatMoney(this.subtotal);
        this.$('subtotal').innerHTML = renderValue;
    }
})


